import { Link } from "react-router-dom";
import { Phone, ArrowRight, MapPinOff } from "lucide-react";
import { SITE } from "@/data/site";
import { Seo } from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo
        title="Page introuvable | HRC Rénovation"
        description="Cette page n'existe pas ou plus. Retrouvez HRC Rénovation : ravalement de façade, hydrofuge, peinture en Dordogne. ☎ 06 41 96 83 46."
        noindex
      />
      <section className="pt-[120px] pb-24 min-h-[80vh] flex items-center bg-surface-canvas" data-testid="notfound-section">
        <div className="max-w-[560px] mx-auto px-5 lg:px-6 text-center">
          <span className="inline-flex w-16 h-16 rounded-full bg-brand-highlight items-center justify-center mb-8">
            <MapPinOff size={28} className="text-brand-royal" aria-hidden="true" />
          </span>
          <p className="micro-label mb-4">Erreur 404</p>
          <h1 className="font-heading font-bold text-3xl sm:text-4xl text-brand-deep" data-testid="notfound-h1">
            Cette page n'existe pas.
          </h1>
          <p className="mt-5 text-lg text-ink-secondary">
            Le lien est peut-être obsolète ou mal orthographié. Retournez à l'accueil ou contactez-nous directement.
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link to="/" className="btn-base btn-metal w-full sm:w-auto" data-testid="notfound-home-btn">
              Retour à l'accueil
              <ArrowRight size={18} aria-hidden="true" />
            </Link>
            <a href={SITE.phoneHref} className="btn-base btn-outline-deep w-full sm:w-auto tnum" data-testid="notfound-phone-btn">
              <Phone size={18} aria-hidden="true" />
              {SITE.phone}
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
